import { mockPurchaseHistory } from "../../../mocks/account";

const statusStyles: Record<string, string> = {
  active: "bg-sky-100 text-sky-700",
  lost: "bg-slate-100 text-slate-500",
  won: "bg-emerald-100 text-emerald-700",
};

export default function PurchaseHistory() {
  const total = mockPurchaseHistory.reduce((s, o) => s + o.amount, 0);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-bold text-slate-900 text-xl font-playfair">Bestellverlauf</h2>
          <p className="text-slate-500 text-sm mt-0.5">{mockPurchaseHistory.length} Bestellungen — Gesamt investiert: <strong>{total}€</strong></p>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[
          { label: "Gesamt investiert", val: `${total}€`, icon: "ri-money-euro-circle-line", color: "text-sky-500", bg: "bg-sky-50" },
          { label: "Teilgenommene Ziehungen", val: mockPurchaseHistory.length, icon: "ri-trophy-line", color: "text-primary", bg: "bg-amber-50" },
          { label: "Gekaufte Lose", val: mockPurchaseHistory.reduce((s, o) => s + o.tickets, 0), icon: "ri-ticket-2-line", color: "text-secondary", bg: "bg-emerald-50" },
        ].map((c) => (
          <div key={c.label} className="bg-white rounded-xl border border-slate-100 p-4 flex items-center gap-4">
            <div className={`w-11 h-11 ${c.bg} ${c.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
              <i className={`${c.icon} text-xl`}></i>
            </div>
            <div>
              <p className="font-bold text-slate-900 text-lg">{c.val}</p>
              <p className="text-slate-500 text-xs">{c.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Orders Table */}
      <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100">
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Bestellung</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Datum</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Paket</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Lose</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Ziehung</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Betrag</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody>
              {mockPurchaseHistory.map((order, i) => (
                <tr key={order.id} className={`border-b border-slate-50 last:border-0 hover:bg-slate-50/60 transition-colors ${i % 2 === 0 ? "" : "bg-slate-50/30"}`}>
                  <td className="px-5 py-4">
                    <p className="font-mono text-sm text-slate-800 font-semibold">{order.id}</p>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm text-slate-600">{order.date}</p>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm font-medium text-slate-700">{order.package}</p>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm text-slate-600">{order.tickets} Lose</p>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm text-slate-600">#{order.draw}</p>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm font-bold text-slate-900">{order.amount}€</p>
                  </td>
                  <td className="px-5 py-4">
                    <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusStyles[order.status]}`}>
                      {order.statusLabel}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
